import { constants } from "@src/constants"

export const getAddress = (chainId: number, contract: any) =>
  constants[chainId].addresses[contract]
